import RailsResource from './rails-resource';

class PushNotificationService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'push-notifications',
      ajaxLoader: false
    });
  }

  subscription(subscription) {
    return this.rawCall(`${this.url}/${this.resource}/subscription`, { method: 'post', body: { subscription: subscription.toJSON() }, parseJSON: false });
  }

  push(subscription) {
    return this.rawCall(`${this.url}/${this.resource}/push`, { method: 'post', body: { subscription: subscription.toJSON() }, parseJSON: false });
  }
}

export default new PushNotificationService();